<template>
  <div class="container">
    <h1 class="title">CONTATO</h1>

    <div class="content-contato">
      <div class="left">
        <form>
          <div class="input-container">
            <input
              v-model="name"
              class="input-field"
              type="text"
              name="name"
              placeholder="Nome:"
              required
            />
          </div>

          <div class="input-container">
            <input
              v-model="telefone"
              class="input-field"
              type="text"
              name="telefone"
              placeholder="Telefone:"
              required
            />
          </div>

          <div class="input-container">
            <input
              v-model="email"
              class="input-field"
              type="email"
              name="email"
              placeholder="Email:"
              required
            />
          </div>

          <div class="input-container">
            <textarea
              v-model="message"
              class="input-field"
              name="message"
              cols="30"
              rows="4"
              placeholder="Mensagem:"
              required
            ></textarea>
          </div>

          <div class="buttons">
            <button
              class="btn"
              type="submit"
              id="send-button"
              @click="submitEmail"
              :disabled="isSubmitDisabled"
            >
              Enviar
              <img
                src="../assets/Email.svg"
                alt="Email Icon"
                class="icon-email"
              />
            </button>

            <div class="whatsapp-button">
              <button
                type="button"
                id="whatsapp-main-button"
                @click="voidFunction"
              >
                <img
                  src="../assets/whatsapp-icon.png"
                  alt="WhatsApp Icon"
                  class="icon-whatsapp"
                />
                WhatsApp
                <img
                  src="../assets/arrow-icon.png"
                  alt="Arrow Icon"
                  class="icon-arrow"
                />
              </button>
              <div class="whatsapp-dropdown">
                <button
                  type="button"
                  id="cliente-button"
                  @click="whatsappLinkCliente"
                  target="_blank"
                >
                  Cliente
                </button>
                <button
                  type="button"
                  id="fornecedor-button"
                  @click="whatsappLinkFornecedor"
                  target="_blank"
                >
                  Fornecedor
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="right">
        <Map />
        <div class="info">
          <p class="left-info">
            Jürgen Hasenfuss <br />
            (32) 3422-4426 <br />
            (32) 3421-4455 <br />
            jurgen@zecon.com.br
          </p>
          <div class="vertical-line"></div>
          <p class="right-info">
            Rua das Acácias, 700 <br />
            Bairro Pouso Alegre <br />
            Cataguases-MG / Brasil <br />
            CEP: 36774-337
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Map from "../components/Map.vue";
import termosCondicoes from "../assets/TermosCondicoes.pdf";
import { SendMail } from "../services/api/SendMail.js";

export default {
  name: "Contato",
  components: {
    Map,
  },
  data() {
    return {
      condicoesPDF: termosCondicoes,
      name: "",
      telefone: "",
      email: "",
      message: "",
      lastSubmitTime: 0,
      remainingTime: 0,
      siteKey: "6LcKWBspAAAAAFbc2dahL2THApFBdnDjb6Oyz7WM",
    };
  },
  computed: {
    isSubmitDisabled() {
      const currentTime = Date.now();
      const fiveMinutes = 5 * 60 * 1000;
      return currentTime - this.lastSubmitTime < fiveMinutes;
    },
  },
  methods: {
    async submitEmail(event) {
      event.preventDefault();
      if (this.isSubmitDisabled) {
        const remainingSeconds = Math.ceil(
          (this.lastSubmitTime + 5 * 60 * 1000 - Date.now()) / 1000
        );
        this.remainingTime = remainingSeconds;

        return;
      } else if (
        this.name === "" ||
        this.telefone === "" ||
        this.email === "" ||
        this.message === ""
      ) {
        this.showErrorToast("Preencha todos os campos para enviar o email.");
        return;
      }

      try {
        await SendMail(this.name, this.telefone, this.email, this.message);

        this.name = "";
        this.telefone = "";
        this.email = "";
        this.message = "";
        this.lastSubmitTime = Date.now();

        this.showSuccessToast("E-mail enviado com sucesso!");
      } catch (error) {
        this.showErrorToast(
          "Erro ao enviar o e-mail. Por favor, tente novamente."
        );
      }
    },
    showSuccessToast(message) {
      this.$bvToast.toast(message, {
        title: "Sucesso",
        variant: "success",
        autoHideDelay: 3000,
      });
    },
    showErrorToast(message) {
      this.$bvToast.toast(message, {
        title: "Erro",
        variant: "danger",
        autoHideDelay: 3000,
      });
    },
    onCaptchaVerified(response) {
      this.captchaResponse = response;
    },
    whatsappLinkCliente() {
      const phoneNumber = "553234224426";
      const link = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
      window.open(link);
    },
    whatsappLinkFornecedor() {
      const phoneNumber = "553234214455";
      const link = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
      window.open(link);
    },
    voidFunction() {
      return;
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #f5f5f5;
  margin: 0;
  padding: 0;
  max-width: 100vw;
  min-height: auto;
  display: flex;
  flex-direction: column;
}

.popup {
  position: fixed;
  top: 10px;
  right: 10px;
  background-color: #f0f0f0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: block;
  z-index: 1000;
}

/* TÍTULO */
.title {
  color: #343333;
  font-family: "Montserrat", sans-serif;
  font-size: 3em;
  font-weight: 300;
  text-align: center;
  padding: 4vh 0 0 0;
  position: relative;
}

.title::after {
  content: "";
  display: block;
  width: 2.3em;
  height: 0.09em;
  background-color: #343333cc;
  opacity: 0.8;
  border-radius: 30px;
  margin: 0.1em 0 0 0;
  position: relative;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
}

/* CONTEÚDO ABAIXO DO TÍTULO */

.content-contato {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 4vh 6vw;
}

/* ESQUERDA */

.left {
  flex: 4;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
}

.left form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.input-container {
  width: 100%;
}

.input-field {
  width: 85%;
  margin: 0 5% 5%;
  padding: 3.2%;
  outline: none;
  border: 1px solid #000;
  box-shadow: 2.6px 2.6px 5.3px 0px rgba(0, 0, 0, 0.6);
  font-size: 1.4em;
}

.input-field:focus {
  outline: none;
}

.input-field::placeholder {
  color: #333;
}

textarea {
  resize: none;
}

.buttons {
  width: 85%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;

  color: #16181a;
  background-color: #ffc737;

  font-family: "Montserrat", sans-serif;
  font-size: 120%;
  font-weight: 400;
  text-align: center;

  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 4px 4px 6px #00000080;
}

.buttons a {
  text-decoration: none;
  flex: 5;
}

#send-button {
  display: flex;
  flex: 5;
  width: 100%;
  height: 60px;
  padding: 0.6em 0em;
  margin: 0.4em 5% 0.4em 0em;
}

.icon-email {
  height: auto;
  width: 1em;
  margin-left: 5%;
}

.whatsapp-button {
  position: relative;
  display: inline-block;
  flex: 5;
}

#whatsapp-main-button {
  background-color: #28b63e;
  color: #fff;

  font-family: "Montserrat", sans-serif;
  font-size: 110%;
  font-weight: 300;
  text-align: center;

  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 4px 4px 6px #00000080;

  flex: 5;
  width: 100%;
  height: 60px;
  padding: 0.6em 0em;
  margin: 0.4em 5% 0.4em 0em;

  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: CENTER;
}

.whatsapp-text {
  margin-left: 5px;
}

.icon-whatsapp {
  height: auto;
  width: 1em;
  margin-right: 5%;
  margin-left: 5%;
}

.icon-arrow {
  height: auto;
  width: 1em;
  margin-right: 5%;
  margin-left: 5%;
}

.whatsapp-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
}

#cliente-button,
#fornecedor-button {
  background-color: #28b63e;
  color: #fff;

  font-family: "Montserrat", sans-serif;
  font-size: 120%;
  font-weight: 300;
  text-align: center;

  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 4px 4px 6px #00000080;

  width: 100%;
  height: 50px;
  padding: 0.6em 0em;
  margin: 0.3em 5% 0.3em 0em;
}

.whatsapp-button:hover .whatsapp-dropdown {
  display: block;
}

/* DIREITA */

.right {
  flex: 6;
}

.info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5vh 0 0 0;
}

.info p {
  color: #343333;
  text-align: center;
  font-family: "Montserrat";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5em;
}

.vertical-line {
  width: 1px;
  height: 120px;
  margin: 0 4%;
  background-color: black;
}

@media screen and (max-width: 1160px) {
  .icon-whatsapp {
    height: 0;
    width: 0;
    margin-right: 5%;
    margin-left: 5%;
  }
}

@media screen and (max-width: 992px) {
  .content-contato {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .input-field {
    width: 90%;
  }

  .left {
    margin-bottom: 10vh;
  }

  .info {
    margin-top: 5vh;
    margin-bottom: 1vh;
  }

  .info p {
    font-size: 13px;
  }

  .vertical-line {
    width: 1.5px;
    height: 100px;
  }

  .icon-whatsapp {
    height: auto;
    width: 1em;
    margin-right: 5%;
    margin-left: 5%;
  }
}

@media screen and (max-width: 450px) {
  .icon-whatsapp {
    height: 0;
    width: 0;
  }
}
</style>
